export const defaultSections = [
  {
    id: 1,
    title: "Personal Details",
    fields: [
      { id: 1, label: "Name", value: "Enter Name" },
      { id: 2, label: "Date Of Birth", value: "Enter Date Of Birth" },
      { id: 3, label: "Time Of Birth", value: "Enter Time Of Birth" },
      { id: 4, label: "Place Of Birth", value: "Enter Place Of Birth" },
      { id: 5, label: "Education", value: "Enter Education" },
      { id: 6, label: "Occupation", value: "Enter Occupation" },
      { id: 7, label: "Income", value: "Enter Income" }
    ]
  },
  {
    id: 2,
    title: "Family Details",
    fields: [
      { id: 8, label: "Father's Name", value: "Enter Father's Name" },
      { id: 9, label: "Father's Occupation", value: "Enter Father's Occupation" },
      { id: 10, label: "Mother's Name", value: "Enter Mother's Name" },
      { id: 11, label: "Mother's Occupation", value: "Enter Mother's Occupation" }
    ]
  },
  {
    id: 3,
    title: "Contact Details",
    fields: [
      { id: 12, label: "Contact Person", value: "Enter Contact Person" },
      { id: 13, label: "Contact Number", value: "Enter Contact Number" },
      { id: 14, label: "Residential Address", value: "Enter Residential Address" }
    ]
  }
];